




















































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  getStudentAppearListApi,
  sourceTypeSelectListApi,
} from "@/api/storeManagement";
import { salesHitherto } from "@/api/statistics";
import { dateFormat, getCurrentMonth } from "@/utils/timeFormat";
import comprehensiveTable from "./comprehensive.vue";
import appearTable from "./appear.vue";
import channelTable from "./channel.vue";
import courseTable from "./course.vue";
import { roundNumbers } from "@/utils/roundNumbers";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
@Component({
  components: {
    comprehensiveTable,
    appearTable,
    channelTable,
    courseTable,
    commonStaffPullDown,
  },
})
export default class extends Vue {
  mtd: any[] = [];
  ytd: any[] = [];
  studentAppearList: any[] = [];
  sourceList: any[] = [];
  searchInfo: any = {
    mouthTime: [],
  };
  checkTabs: number = 1;
  start: string = "";
  end: string = "";
  searchData = {};
  created() {
    getStudentAppearListApi({
      page: 1,
      page_size: 500,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.studentAppearList = res.data.list;
      }
    });
    sourceTypeSelectListApi().then((res: any) => {
      if (res.error_code === 0) {
        this.sourceList = res.data.list;
      }
    });
    this.getMonthTime();
  }
  async beforeMount() {
    await salesHitherto().then((res: any) => {
      if (res.error_code === 0) {
        const studentArr: any = {
          title: "学员数据",
          popover1: "名单数：新录入的意向学员",
          popover2: "在读学员：查询时间最后一刻的在读学员数量",
          n: 1,
          arr: [
            {
              name: "名单数",
              num: res.data.mtd.roster_num,
              route_name: "",
              key: "",
            },
            {
              name: "在读学员",
              num: res.data.mtd.on_going_num,
              route_name: "",
              key: "",
            },
          ],
        };
        const stageArr: any = {
          title: "阶段数据",
          popover3: "已联络：所有已联络状态的意向学员",
          popover4: "诺访：所有诺访状态的意向学员",
          popover5: "已到访：所有已到访状态的意向学员",
          popover6: "已转化：所有已转化状态的意向学员",
          popover7: "订单金额：已转化意向学员有效订单金额统计",
          n: 2,
          arr: [
            {
              name: "已联络",
              num: res.data.mtd.connected_num,
              route_name: "follow",
              key: 1,
            },
            {
              name: "诺访",
              num: res.data.mtd.committed_to_visit_num,
              route_name: "follow",
              key: 3,
            },
            {
              name: "已到访",
              num: res.data.mtd.visited_num,
              route_name: "follow",
              key: 4,
            },
            {
              name: "已转化",
              num: res.data.mtd.transformed_num,
              route_name: "follow",
              key: 6,
            },
            {
              name: "订单金额",
              num: roundNumbers(res.data.mtd.order_amount),
              route_name: "",
              key: "",
            },
          ],
        };
        const transformArr = {
          title: "转化率",
          popover8: "诺访到访率 = 已到访数 / 诺访数 * 100%",
          popover9: "到访转化率 = 已转化数 / 已到访数 * 100%",
          popover10: "名单转化率 = 已转化数 / 名单数 * 100%",
          n: 3,
          arr: [
            {
              name: "诺访到访率",
              num: roundNumbers(res.data.mtd.visit_nuo_transform) + "%",
              route_name: "",
              key: "",
            },
            {
              name: "到访转化率",
              num: roundNumbers(res.data.mtd.visit_transform) + "%",
              route_name: "",
              key: "",
            },
            {
              name: "名单转化率",
              num: roundNumbers(res.data.mtd.roster_transform) + "%",
              route_name: "",
              key: "",
            },
          ],
        };
        this.mtd.push(studentArr, stageArr, transformArr);
        const ytdStudentArr = {
          title: "学员数据",
          popover1: "名单数：新录入的意向学员",
          popover2: "在读学员：查询时间最后一刻的在读学员数量",
          n: 1,
          arr: [
            {
              name: "名单数",
              num: res.data.ytd.roster_num,
            },
            {
              name: "在读学员",
              num: res.data.ytd.on_going_num,
            },
          ],
        };
        const ytdStageArr: any = {
          title: "阶段数据",
          popover3: "已联络：所有已联络状态的意向学员",
          popover4: "诺访：所有诺访状态的意向学员",
          popover5: "已到访：所有已到访状态的意向学员",
          popover6: "已转化：所有已转化状态的意向学员",
          popover7: "订单金额：已转化意向学员有效订单金额统计",
          n: 2,
          arr: [
            {
              name: "已联络",
              num: res.data.ytd.connected_num,
            },
            {
              name: "诺访",
              num: res.data.ytd.committed_to_visit_num,
            },
            {
              name: "已到访",
              num: res.data.ytd.visited_num,
            },
            {
              name: "已转化",
              num: res.data.ytd.transformed_num,
            },
            {
              name: "订单金额",
              num: roundNumbers(res.data.ytd.order_amount),
            },
          ],
        };
        const ytdTransformArr = {
          title: "转化率",
          popover8: "诺访到访率 = 已到访数 / 诺访数 * 100%",
          popover9: "到访转化率 = 已转化数 / 已到访数 * 100%",
          popover10: "名单转化率 = 已转化数 / 名单数 * 100%",
          n: 3,
          arr: [
            {
              name: "诺访到访率",
              num: roundNumbers(res.data.ytd.visit_nuo_transform) + "%",
            },
            {
              name: "到访转化率",
              num: roundNumbers(res.data.ytd.visit_transform) + "%",
            },
            {
              name: "名单转化率",
              num: roundNumbers(res.data.ytd.roster_transform) + "%",
            },
          ],
        };
        this.ytd.push(ytdStudentArr, ytdStageArr, ytdTransformArr);
      }
    });
  }
  handleSearch() {
    const monthStartArr = getCurrentMonth(this.searchInfo.mouthTime[0]);
    const monthEndArr = getCurrentMonth(this.searchInfo.mouthTime[1]);
    const start = dateFormat("YYYY-mm-dd", monthStartArr[0]);
    const end = dateFormat("YYYY-mm-dd", monthEndArr[1]);
    this.searchInfo.start_time = start;
    this.searchInfo.end_time = end;
    this.searchData = this.searchInfo;
  }
  getMonthTime() {
    const now = new Date();
    const monthArr = getCurrentMonth(now);
    this.start = dateFormat("YYYY-mm-dd", monthArr[0]);
    this.end = dateFormat("YYYY-mm-dd", monthArr[1]);
    this.searchInfo.mouthTime[0] = this.start.slice(0, 7);
    this.searchInfo.mouthTime[1] = this.end.slice(0, 7);
    this.handleSearch();
  }
  goTetail(val: string, key: any | number) {
    if (val !== "" && key !== "") {
      const detail = this.$router.resolve({
        name: val,
        query: {
          key: key,
          from: "salesData",
          s_time: this.start,
          e_time: this.end,
        },
      });
      window.open(detail.href, "_blank");
    }
  }
}
